// extracted by mini-css-extract-plugin
export default {"link":"xD-z","disabled":"yD-z"};